export default "__VITE_ASSET___3yHKtHb__"